const currencyFormatter = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
  minimumFractionDigits: 2,
});

export const toCurrency = (amount: number, fromCents = false) =>
  currencyFormatter.format(fromCents ? amount / 100 : amount);
